import {
    Box,
    Stack,
    DarkMode,
    Center,
    Image
} from '@chakra-ui/react'
import { Container } from '@/-components/Container'
import { Headline } from '@/-components/Headline'

export const ChooseRarchy = () => {
    return (
        <DarkMode>
            <Container as='section'
                position='relative'
                borderRadius="32px"
                mx={{ base: 6, xl: 'auto' }}
                backgroundImage='linear-gradient(to right, blue.600, blue.500)'>
                <Stack
                    px={{ base: 6, md: 16 }}
                    py={{ base: 16, md: 20 }}
                    maxW={{ base: 'full', lg: '7xl' }}
                    direction={{ base: 'column', lg: 'row' }}
                    spacing={{ base: 10, lg: '24' }}
                >
                    <Stack spacing={{ base: 6, md: 20 }} direction={{ base: 'row', md: 'column' }}>
                        <Headline
                            heading='Why choose Rarchy?'
                            textAlign="left"
                        />
                        <Center>
                            <Image src="/images/misc/party-popper.svg" alt="Party Popper Icon" width={{ base: "60px", md: "225px" }} mt={{ base: -1, md: 0 }} />
                        </Center>
                    </Stack>
                    <Stack
                        maxWidth={{ base: 'unset', lg: '30rem' }}
                        marginX='auto'
                        position='relative'
                        fontSize={{ base: "lg", lg: "xl" }}
                        spacing={6}
                        color="fg.default"
                    >
                        <Box>
                            With Rarchy, you can ensure your visual sitemaps capture every page by generating your sitemap from a fresh crawl of your website.
                        </Box>
                        <Box>
                            Most visual sitemap generators can only import an existing XML sitemap, and do not have crawl functionality. This can result in out-of-date website visualizations as these files don’t always reflect recent changes to your website.
                        </Box>
                        <Box>
                            By generating your visual sitemap with Rarchy based on a fresh crawl of your website, you can guarantee an up-to-date visualization of your website and ensure that every page is captured.
                        </Box>
                    </Stack>

                </Stack>
            </Container>
        </DarkMode>
    )
}